import { PoiCategory } from 'types/feature/poi/poi';

// parking이라는 단어가 title에 포함되어 있는지 확인하는 함수
export function hasParkingInCategories(categories: PoiCategory[]): boolean {
  return categories.some(category => {
    return Object.values(category.title).some(value => value.toLowerCase().includes('parking'));
  });
}
